<div class="home" *ngIf="authorized">
  <akce-ukon-statistics></akce-ukon-statistics>
  <akce-ukoly></akce-ukoly>
  <akce-notifikace></akce-notifikace>
</div>
<help [helpId]="helpIds.DOSS_AKCE_OVERVIEW" class="cm-help-page"></help>
